import {
	ADMINADDINTEGRATION_SUCCESS,
	ADMINADDINTEGRATION_FAILED,
	RESET_ADMINADDINTEGRATION,
	LOADING_ADMINADDINTEGRATION,
	NETWORK_ERROR_ADMINADDINTEGRATION
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINADDINTEGRATION:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINADDINTEGRATION_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINADDINTEGRATION_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINADDINTEGRATION:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINADDINTEGRATION:
			return (state = initialState);
		default:
			return state;
	}
};
